import React, { createContext, useContext, useRef, useState, useEffect } from "react";
import backgroundMusic from "../../audios/game backgrounf.mp3";

const MusicContext = createContext();

export const MusicProvider = ({ children }) => {
  const audioRef = useRef(new Audio(backgroundMusic));

  const [muted, setMuted] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;

    audio.loop = true;
    audio.volume = 0.4;

    return () => {
      audio.pause();
    };
  }, []);

  const playMusic = () => {
    const audio = audioRef.current;
    audio.play().catch(() => {});
    setMuted(false);
  };

  const muteMusic = () => {
    const audio = audioRef.current;
    audio.pause();
    setMuted(true);
  };

  const toggleMute = () => {
    const audio = audioRef.current;

    if (muted) {
      audio.play().catch(() => {});
      setMuted(false);
    } else {
      audio.pause();
      setMuted(true);
    }
  };

  return (
    <MusicContext.Provider value={{ muted, playMusic, muteMusic, toggleMute }}>
      {children}
    </MusicContext.Provider>
  );
};

export const useMusic = () => useContext(MusicContext);